import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Library from "./pages/Library";
import SermonDetail from "./pages/SermonDetail";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ChangePassword from "./pages/ChangePassword";
import Study from "./pages/Study";
import StudyEditor from "./pages/StudyEditor";
import StudySettings from "./pages/StudySettings";
import StudyLibrary from "./pages/StudyLibrary";
import Pulpit from "./pages/Pulpit";

function RequireAdmin({ children, allowTemp = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-[60vh] flex items-center justify-center text-lg text-[#3F433C]">Verificando…</div>;
  if (!user) return <Navigate to="/estudio/login" replace />;
  if (!user.is_admin) return <Navigate to="/" replace />;
  if (user.must_change_password && !allowTemp) return <Navigate to="/estudio/cambiar-clave" replace />;
  return children;
}

function Shell({ children, hideChrome = false }) {
  if (hideChrome) return <>{children}</>;
  return (
    <>
      <Header />
      <main className="min-h-[60vh]">{children}</main>
      <Footer />
    </>
  );
}

function AppRouter() {
  const location = useLocation();
  const isPulpit = location.pathname.startsWith("/pulpito/");

  return (
    <Shell hideChrome={isPulpit}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/predicas" element={<Library />} />
        <Route path="/predicas/:id" element={<SermonDetail />} />
        <Route path="/login" element={<Navigate to="/estudio/login" replace />} />
        <Route path="/estudio/login" element={<Login />} />
        <Route path="/estudio/olvide" element={<ForgotPassword />} />
        <Route path="/estudio/restablecer" element={<ResetPassword />} />
        <Route path="/estudio/cambiar-clave" element={<RequireAdmin allowTemp><ChangePassword /></RequireAdmin>} />
        <Route path="/estudio" element={<RequireAdmin><Study /></RequireAdmin>} />
        <Route path="/estudio/ajustes" element={<RequireAdmin><StudySettings /></RequireAdmin>} />
        <Route path="/estudio/biblioteca" element={<RequireAdmin><StudyLibrary /></RequireAdmin>} />
        <Route path="/estudio/predica/:id" element={<RequireAdmin><StudyEditor /></RequireAdmin>} />
        <Route path="/pulpito/:id" element={<Pulpit />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Shell>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster richColors position="top-right" />
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
